'use strict';

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Status, TrackingConstants, setOpenFilterName } from './cfs-search-slice';

import analytics from '../../../utils/analytics';
import layout from '../../../ui/layout';

export const SortButtons = ({ selectedSort }) => {
	const dispatch = useDispatch();

	const filterStatus = useSelector((state) => state.cfsSearch.filterStatus);

	const onSortClick = (e) => {
		e.preventDefault();

		analytics.trackEvent(TrackingConstants.Categories.SortOrder, 'Sort options opened', layout.getScreenSize());
		dispatch(setOpenFilterName('sortOrder'));
	}

	const onFiltersClick = (e) => {
		analytics.trackEvent(TrackingConstants.Categories.FiltersOpened, 'Sticky Tab Click', layout.getScreenSize());
	}

	let sortOrderButtonClassName = 'sort-order-button';

	if (filterStatus === Status.Uninitialised || filterStatus === Status.Loading) {
		sortOrderButtonClassName += ' sort-order-button--loading';
	}

	return (
		<>
			<a className={sortOrderButtonClassName} onClick={onSortClick}>
				<span className="sort-order-button__icon icon-16x16-sort-order-blue"></span>
				<span>{selectedSort}</span>
			</a>

			<div className="sticky-sort-and-filter hide-for-xxlarge">
				<a className="sticky-sort-and-filter__button" onClick={onFiltersClick} data-toggle="offCanvasSearch">
					<span className="sticky-sort-and-filter__button__icon icon-16x16-filters-white"></span>
					<span>Filters</span>
				</a>
				<a className="sticky-sort-and-filter__button" onClick={onSortClick}>
					<span className="sticky-sort-and-filter__button__icon icon-16x16-sort-order-white"></span>
					<span>Sort by</span>
				</a>
			</div>
		</>
	);
}